// @flow
import React, { Component } from 'react'
import { Card, Spin } from 'antd';
import { StyledMember, StyledContent } from './style'
import ApiService from '../../actions/apiService';
import ReactMarkdown from 'react-markdown'

class RefundPolicy extends Component {
  
  state = {
    content: 'Refund Policy',
    isLoading: true,
  }
  
  async componentWillMount() {
    const response = await ApiService.getMethod('/pages/refundpolicy');
    if (response) {
      this.setState({
        content: response,
      })
    }
    this.setState({
      isLoading: false,
    });
  }
  
  render() {
    
    return (
      <StyledContent>
        <StyledMember>
          <Card title="Refund Policy" bordered={false}>
            {
              this.state.isLoading ? <Spin/> : <ReactMarkdown escapeHtml={false} source={this.state.content} />
            }
          </Card>
        </StyledMember>
      </StyledContent>
    )
  }
}

export default RefundPolicy;



// WEBPACK FOOTER //
// ./src/components/static/RefundPolicy.js